import { useEffect } from 'react';

let bodyScrollLockCount = 0;
let previousBodyOverflow = '';
let previousDocumentOverflow = '';

const usePreventBodyScroll = (disableBodyScroll: boolean | undefined = true) => {
  useEffect(() => {
    if (!disableBodyScroll) {
      return undefined;
    }

    if (bodyScrollLockCount === 0) {
      previousDocumentOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
    }

    bodyScrollLockCount += 1;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    return () => {
      bodyScrollLockCount = Math.max(bodyScrollLockCount - 1, 0);

      if (bodyScrollLockCount === 0) {
        document.documentElement.style.overflow = previousDocumentOverflow;
        document.body.style.overflow = previousBodyOverflow;
      }
    };
  }, [disableBodyScroll]);
};

export default usePreventBodyScroll;
